<script setup>
const { university, wishlistId } = defineProps({
  university: Object,
  wishlistId: String,
});

const { getSession } = useAuth();

const removeWishlist = async () => {
  await useApiFetch(`wishlists/${wishlistId}`, {
    method: "DELETE",
    async onResponse() {
      refreshNuxtData("university-wishlists");
      await getSession();
    },
  });
};

function getAttributeData(key) {
  const attribute = university?.attributes?.data?.find((d) => d.key === key);
  return attribute ? attribute.value : "";
}

console.log("soft delete: ", university);
</script>

<template>
  <div class="rounded-lg bg-white border border-slate-200">
    <div class="px-4 py-4 md:px-6">
      <!-- Top Row -->
      <div
        class="flex justify-between items-start md:items-center md:flex-row gap-2"
      >
        <Button
          :label="university?.name"
          class="hover:underline !pl-0 pr-5 text-lg md:text-xl !font-bold text-primary-500 !text-left"
          link
          @click="navigateTo(`/universities/${university?.slug}`)"
          :disabled="university?.deleted_at"
        />
        <Button
          icon="pi pi-trash"
          outlined
          size="small"
          @click="removeWishlist"
          class="hidden md:flex"
        />
        <Button
          icon="pi pi-trash"
          text
          size="small"
          @click="removeWishlist"
          class="flex md:hidden"
        />
      </div>

      <div
        class="flex flex-wrap md:flex-nowrap gap-3 items-center text-slate-800 text-sm mt-3 mb-5"
      >
        <p>{{ university?.type }}</p>
        <p class="border-l border-slate-200 h-4"></p>
        <p>{{ getCitiesName(university?.cities) || "-" }}</p>
      </div>

      <div class="flex flex-col md:flex-row md:gap-6 gap-4">
        <div class="flex gap-3 items-start">
          <i class="pi pi-building pt-1 text-lg text-slate-600"></i>
          <!-- <div>
            <p class="text-sm text-slate-600">
              Asia Ranking {{ new Date().getFullYear() }}
            </p>
            <p class="font-bold text-primary-500 text-base md:text-lg">
              {{ getRankingLabel(university?.ranking) }}
            </p>
          </div> -->
          <div class="space-y-1.5">
            <p class="text-sm text-slate-600">
              Asia Ranking {{ new Date().getFullYear() }}
            </p>
            <p
              :class="[
                getRankingLabel(university?.ranking) === 'Ranking Not Available'
                  ? 'text-base md:text-base text-gray-800'
                  : 'text-base md:text-lg text-primary-500 font-bold',
              ]"
            >
              {{ getRankingLabel(university?.ranking) }}
            </p>
          </div>
        </div>

        <Divider
          type="solid"
          layout="vertical"
          class="hidden md:block before:w-px before:h-8 before:bg-slate-200"
        />

        <div class="flex gap-3 items-start">
          <i class="pi pi-graduation-cap pt-1 text-lg text-slate-600"></i>
          <div class="space-y-1.5">
            <p class="text-sm text-slate-600">Students</p>
            <p class="font-bold text-primary-500 text-base md:text-lg">
              {{ numberFormatter.format(getAttributeData("student_count")) }}
            </p>
          </div>
        </div>

        <Divider
          type="solid"
          layout="vertical"
          class="hidden md:block before:w-px before:h-8 before:bg-slate-200"
        />

        <div class="flex gap-3 items-start">
          <i class="pi pi-book pt-1 text-lg text-slate-600"></i>
          <div class="space-y-1.5">
            <p class="text-sm text-slate-600">Programs</p>
            <p class="font-bold text-primary-500 text-base md:text-lg">
              {{ university?.program_count }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
